import { useEffect, useState } from 'react'
import useLTWCompany from './useLTWCompany'
import ObjectTopPopup from '../_shared/ObjectTop/ObjectTopPopup'
import ObjectTop, { ObjectTopItem } from '../_shared/ObjectTop/ObjectTop'

function LTWCompany() {

  const {
    result,
    top,
    error,
    loading,
    fullMessage,
    isPeriod, setIsPeriod,
    minValue, setMinValue
  } = useLTWCompany()

  const [open, setOpen] = useState(false)
  return (
    <>
      <ObjectTop
        col={15}
        row={8}
        error={error}
        loading={loading}
        title='LTW'
        fullMessage={fullMessage}
        top={top.map(r => ({
          id: Number(r.inn),
          isEmpty: (r as any).isEmpty ?? false,
          name: r.name,
          place: r.place,
          value: String(r.total.toLocaleString()),
          tooltip: r.name
        }))}
        setOpenPopup={() => setOpen(true)}
      />
      <ObjectTopPopup
        data={
          result.map(r => ({
            id: Number(r.inn),
            isEmpty: false,
            name: r.name,
            place: r.place,
            value: String(r.total.toLocaleString()),
            tooltip: r.name
          }))
        }
        loading={loading}
        title='LTW'
        isPeriod={isPeriod}
        setIsPeriod={setIsPeriod}
        onClose={() => setOpen(false)}
        open={open}
        valueFilter={minValue}
        setValueFilter={setMinValue}
      />
    </>
  )
}

export default LTWCompany